import { render, staticRenderFns } from "./SheetDataSettings.vue?vue&type=template&id=3275100e"
import script from "./SheetDataSettings.vue?vue&type=script&lang=js"
export * from "./SheetDataSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports